import React from 'react';
import Title from './UI/Title';
import Text from './UI/Text';
import Contact from './UI/Contact';
import ceoImg from '../images/CEO.jpg';

const About = () => (
  <div>
    <Title>אודותינו</Title>
    <Text>
      רשת דירוגים בע"מ שמה לה למטרה להיות חלוצה ומובילת שוק בתחום של התייעלות אנרגטית וחיסכון בחשמל, הפחתת פליטות ומזהמים ושמירה
      על הסביבה וקידום אנרגיה ירוקה וידידותית לסביבה וכל זאת תוך דגש על השאת רווחים ללקוחותינו.
      <br />
      כל פרויקט אנרגטי מתחיל בביצוע תסקיר כלכלי וסביבתי. בתסקיר זה אנו בוחנים את כל ההיבטים של רשת החשמל- הגריד- וההשפעה של מתקן
      הייצור החדש על איכות הסביבה, קיבולת רשת החשמל וכן כדאיות כלכלית ליזם. 
      <br />
      בעשור האחרון עם התפתחות ייצור האנרגיה במשק החשמל הישראלי, בנינו עבור לקוחותינו סל רחב של פתרונות בייצור חשמל, חיבורו לרשת
      החלוקה/הולכה וכן בתחום חיסכון בחשמל. אנו רואים חשיבות עליונה לשמירת הסביבה ומקדמים בפועלנו ובחזוננו ייצור ושימוש בחשמל נקי
      מזיהום-אוויר והתייעלות אנרגטית לחיסכון בצריכת החשמל אשר מוביל לחיסכון כספי ניכר.
      <br />
      תחום אגירת האנרגיה באמצעות סוללות ליתיום-יון הוא היום התחום המוביל בעולם ליישום זה והכדאי ביותר עבור שימוש מסחרי או ביתי.
      <br />
      פתרון אגירת האנרגיה באמצעות סוללות או באנגלית B.E.S.S – Battery Energy Storage System הינו הפתרון המתקדם, האמין ועם החזר
      ההשקעה הקצר ביותר מבין פתרונות אגירת האנרגיה המוצעים היום.
      <br />
      אנו מציעים פתרון למערכות בהיקף ייצור בינוני של עד 50MWh וכן פתרון של מערכות ביתיות בהספקים נמוכים של 15KWh הדרך הטובה ביותר
      להגיע ל – אפס – פליטות פחמן היא לא לצרוך חשמל, לבצע תהליכים של התייעלות אנרגטית.
      <br />
      ברחבי אירופה ובאוסטרליה קיים ניסיון גדול בתחום של שימוש במייצבי מתח-הורדת מתח הרשת לשם חיסכון בחשמל. התהליך החשמלי והחישוב
      הכספי הוא מאוד פשוט.
      <br />
      רשת החשמל של חברת החשמל מספקת לכל צרכן, מפעל, מוסדי מתח רשת של 400 וולט תלת פאזי וזאת למרות שכל מכשירי החשמל התעשייתים
      והבייתים עובדים במתח עבודה מומלץ על ידי יצרן המכשירים של 370 וולט תלת-פאזי. על ידי התקנת מייצב מתח מרכזי בחדר חשמל ראשי ניתן
      להוריד את המתח המסופק ע"י חח"י ל 370 וולט ובכך למעשה אנו מפחיתים את חשבון החשמל בעשרה אחוזים בקירוב שכן חישוב צריכת החשמל
      נעשה במכפלה של מתח*זרם= הספק. הפחתה של המתח בהכרח תביא להפחתה של ההספק והספק השעה קוט"ש אשר מופיע בחשבון החשמל. החזר ההשקעה
      הוא קצר, שנים בודדות ואורך חיי המכשיר 25 שנה. <br /> <br />
      <p className='text-center text-3xl font-semibold'>Energizing a Sustainable Environment <br/> <br /> פנה אלינו לקבלת תסקיר סביבתי כלכלי לפרויקט האנרגיה שלך!</p>
    </Text>

    <div className='container lg:w-2/4 mx-auto text-center flex flex-col'>
      <img
        src={ceoImg}
        alt='שרון אייזיק המנכל'
        width='50'
        className='shadow-lg border border-gray-400 mx-auto transform rotate-18 mb-10 mt-20 rounded-full h-48 w-48 lg:h-80 lg:w-80 text-center'
      />
      {/* REMEMEBER TO USE PROPERLY SIZED IMAGES AND EXPLICIT width AND height */}
      <h1 className='text-4xl lg:text-5xl mb-10 font-secular'> שרון אייזיק, המנכ"ל</h1>
      <p className='text-center text-xl md:text-2xl mx-5 max-w-6xl'>
        החברה מנוהלת על ידי מר שרון אייזיק, בעל 20 שנות ניסיון במשק האנרגיה בישראל, עת התחיל את הקריירה בחברת דלק בשנת 1997. לשרון
        תואר ראשון בסטטיסטיקה מאוניברסיטת חיפה, תואר שני במנהל עסקים מאוניברסיטת הריוט-וואט באדינבורו, סקוטלנד וכן בוגר קורס
        "כלכלת אנרגיה" של הטכניון, מכון טכנולוגי לישראל. ובוגר קורס "הכשרת דירקטורים ונושאי משרה" גם הוא מהטכניון.
      </p>
    </div>

    <p className='text-4xl lg:text-4xl text-center mt-20 mb-10 font-sans'>צרו קשר</p>

    <Contact size='small' />
  </div>
);

export default About;
